import {createFeatureSelector} from '@ngrx/store';
import {DevicesState} from './devices.state';

export const selectDevicesState = createFeatureSelector<DevicesState>('orga-portal-feature-devices');
